import type { Track, Vec2 } from '../game/types'

export const SKYLINE_TRACK_CLEARANCE = 48
const SKYLINE_CANDIDATE_COUNT = 72

export interface SkylineBuilding {
  index: number
  position: Vec2
  rotation: number
  height: number
  width: number
}

export function createSkylineBuildings(track: Track): SkylineBuilding[] {
  return Array.from({ length: SKYLINE_CANDIDATE_COUNT }, (_, index) => {
    const angle = (index / SKYLINE_CANDIDATE_COUNT) * Math.PI * 2
    const radius = 220 + Math.sin(index * 41.7) * 10
    const position = { x: Math.sin(angle) * radius, y: Math.cos(angle) * radius }
    const height = 8 + ((Math.sin(index * 17.3) + 1) / 2) * 20
    const width = 4 + ((Math.cos(index * 9.2) + 1) / 2) * 6
    return { index, position, rotation: angle * 0.7, height, width }
  }).filter((building) =>
    track.samples.every(
      (sample) =>
        Math.hypot(building.position.x - sample.position.x, building.position.y - sample.position.y) >=
        SKYLINE_TRACK_CLEARANCE,
    ),
  )
}
